// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".portal-dialog[data-v-1724e65b]{height:100%;width:100%;position:fixed;top:0;z-index:999;pointer-events:none;padding:16px;display:flex;flex-direction:column}@media(max-width:599.9px){.portal-dialog[data-v-1724e65b]{padding:0!important}}.portal-dialog[data-v-1724e65b] >*{pointer-events:all}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
